import { CryptoTokenType } from 'src/app/shared/entities/crypto-token-type';
import { CreateCryptoTokenRequestDto } from 'src/app/shared/services/api/dto/create-crypto-token-request-dto';

export enum CryptoTokenField {
  secret = 'secret', // secret name or password
  tokenName = 'tokenName',
  tokenType = 'tokenType',
  autoActivation = 'autoActivation',
  slotLabel = 'slotLabel',
}

export interface CryptoTokenFormValue {
  [CryptoTokenField.secret]?: string | null;
  [CryptoTokenField.tokenName]?: string | null;
  [CryptoTokenField.tokenType]?: CryptoTokenType | null;
  [CryptoTokenField.autoActivation]?: boolean | null;
  [CryptoTokenField.slotLabel]?: string | null;
}

export const AUTO_ACTIVATION_DEFAULT = true;

// formValue is assumed valid.  Validation is performed by the form.
export function cryptoTokenFormValueToDto(
  formValue: CryptoTokenFormValue,
): CreateCryptoTokenRequestDto {
  const isPKCS11 =
    formValue[CryptoTokenField.tokenType] === CryptoTokenType.PKCS11;
  const usesSecretName = !!formValue[CryptoTokenField.autoActivation];
  return {
    secretName: usesSecretName
      ? (formValue[CryptoTokenField.secret] ?? '')
      : null,
    password: !usesSecretName
      ? (formValue[CryptoTokenField.secret] ?? '')
      : null,
    tokenName: formValue[CryptoTokenField.tokenName] ?? '',
    tokenType: formValue[CryptoTokenField.tokenType] ?? CryptoTokenType.SOFT,
    autoActivation: !!formValue[CryptoTokenField.autoActivation],
    slotLabel: isPKCS11
      ? (formValue[CryptoTokenField.slotLabel] ?? undefined)
      : undefined,
  };
}
